document.addEventListener('DOMContentLoaded', () => {
  // Initialize product sliders only for screens wider than 1024px
  if (window.innerWidth >= 1024) {
      initializeProductSliders();
  }
});

// Function to initialize product sliders
function initializeProductSliders() {
  // Select all product sliders on the page
  const productSliders = document.querySelectorAll('.product-slider');

  // Loop through each slider
  productSliders.forEach((slider) => {
      // Get individual slides and relevant elements
      const productSlides = slider.querySelectorAll('.product-slide');
      const totalSlides = productSlides.length;
      const currentSlideElement = slider.querySelector('.current-product-slide');
      const totalSlidesElement = slider.querySelector('.total-product-slide');
      const prevButton = slider.querySelector('.product-slider-prev');
      const nextButton = slider.querySelector('.product-slider-next');
      let currentSlide = 0; // Track the current slide index


      // Function to update button states based on the current slide
      function updateButtons() {
          const isSingleSlide = totalSlides <= 1;
          prevButton.disabled = isSingleSlide || currentSlide === 0;
          nextButton.disabled = isSingleSlide || currentSlide === totalSlides - 1;


          // Update cursor styles for buttons
          prevButton.style.cursor = prevButton.disabled ? 'not-allowed' : 'pointer';
          nextButton.style.cursor = nextButton.disabled ? 'not-allowed' : 'pointer';
      }

      // Function to display the selected slide
      function showSlide(index, slideType) {
          productSlides.forEach((slide, i) => {
              // Remove all classes from slides
              slide.classList.remove('show', 'previous', 'next', 'hide', 'md:-translate-x-6', 'md:translate-x-6');

              // Add classes based on the current slide index
              if (i === index) {
                  slide.classList.add('show');
                  if (slideType) slide.classList.add(slideType);
              } else if (i === index + 1) {
                  slide.classList.add('md:-translate-x-6');
              } else {
                  // Add classes for previous and next slides
                  if (slideType === 'next' && i === index - 1) slide.classList.add('hide', 'next');
                  if (slideType === 'previous' && i === index + 1) slide.classList.add('hide', 'previous');
                  if (slideType === 'next' && i === index + 1) slide.classList.add('md:-translate-x-6');
                  if (slideType === 'previous' && i === index - 1) slide.classList.add('md:translate-x-6');
              }
          });

          // Update button states
          updateButtons();

          // Update the current slide text display
          const currentProductValues = (+index + 1) * 4;
          currentSlideElement.textContent = Math.min(currentProductValues, totalSlidesElement.textContent);
      }

      // Event listener for the previous button
      prevButton.addEventListener('click', () => {
          // Decrement currentSlide or wrap to the last slide
          currentSlide = currentSlide > 0 ? currentSlide - 1 : totalSlides - 1;
          showSlide(currentSlide, 'previous'); // Show the slide
      });

      // Event listener for the next button
      nextButton.addEventListener('click', () => {
          // Increment currentSlide or wrap to the first slide
          currentSlide = currentSlide < totalSlides - 1 ? currentSlide + 1 : 0;
          showSlide(currentSlide, 'next');
      });

      // Show the initial slide
      showSlide(currentSlide, '');
  });
}

// Function to open a collection when a tab is clicked
function openCollection(evt, collectionName) {
  const section = evt.currentTarget.closest('.section-product-block');
  const currentContent = section.querySelector('.active-content');
  const newContent = section.querySelector(`#${collectionName}`);

  // If current content exists and is different from new content, fade it out
  if (currentContent && currentContent !== newContent) {
      fadeOut(currentContent, () => {
          currentContent.classList.remove('active-content');
          setActiveContent(newContent);
      });
  } else {
      setActiveContent(newContent);
  }

  setActiveTab(evt.currentTarget);
  initializeProductSliders();
}


// Function to set the new content as active
function setActiveContent(newContent) {
  newContent.classList.remove('hidden');
  newContent.classList.add('active-content');
  fadeIn(newContent);
}

// Function to set the active tab
function setActiveTab(activeTab) {
  const tabContainer = activeTab.closest('ul');
  const allTabs = tabContainer.querySelectorAll('.tablink');

  // Remove active class from all tabs
  allTabs.forEach((tab) => {
      tab.classList.remove('active');
  });

  activeTab.classList.add('active');
}

// Function to fade out an element
function fadeOut(element, callback) {
  element.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  element.style.opacity = '1';
  element.style.transform = 'translateX(0)';
  element.offsetHeight;

  // Start fading out
  requestAnimationFrame(() => {
      element.style.opacity = '0';
      element.style.transform = 'translateX(24px)';
  });

  // After transition ends, hide the element and call the callback
  setTimeout(() => {
      element.classList.add('hidden');
      if (typeof callback === 'function') callback();
  }, 600);
}

// Function to fade in an element
function fadeIn(element) {
  element.classList.remove('hidden');
  element.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  element.style.opacity = '0';
  element.style.transform = 'translateX(-24px)';

  element.offsetHeight;

  // Start fading in
  requestAnimationFrame(() => {
      element.style.opacity = '1';
      element.style.transform = 'translateX(0)';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  // Function to set scroll position
  const setScrollPosition = (scrollContainer) => {
    if (scrollContainer) {
      const targetScrollLeft = scrollContainer.offsetWidth * (window.innerWidth < 768 ? 0.25 : 0.15);
      if (scrollContainer.scrollLeft !== targetScrollLeft) {
        scrollContainer.scrollLeft = targetScrollLeft;
      }
    }
  };

  // Apply scroll position to existing containers
  const applyScrollToContainers = () => {
    const scrollContainers = document.querySelectorAll('.product-scroll-container, .pdp-product-scroll-container');
    scrollContainers.forEach(setScrollPosition);
  };

      // Debounce function to limit frequent calls
      const debounce = (func, wait) => {
        let timeout;
        return (...args) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => func(...args), wait);
        };
      };

  // Initial scroll position on page load
  applyScrollToContainers();

  // Reapply scroll position after tab switches
  const tablinks = document.querySelectorAll('.tablink');
  const applyScrollToContainersDebounced = debounce(applyScrollToContainers, 100);

  tablinks.forEach((tab) => {
    tab.addEventListener('click', applyScrollToContainersDebounced);
  });

  // Observe for dynamically added .pdp-product-scroll-container elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.matches('.pdp-product-scroll-container')) {
          setScrollPosition(node);
        }
      });
    });
  });

  const observerTarget = document.body;
  observer.observe(observerTarget, { childList: true, subtree: observerTarget === document.body });
});